import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const MechanicalMaintenanceHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Mantenimiento Mecánico"
    text="Éste es el módulo de Gestión de Mantenimiento Mecánico."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  cards: MechanicalMaintenanceUnit.UnitHome.get('cards'),
  breadcrumbs: MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
});

MechanicalMaintenanceHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(MechanicalMaintenanceHome);
